import { transformFaqEntryDto } from './faq-entry';
export const transformComplaintPhoto = photo => ({
  url: photo.url
});
export const transformComplaintPhotos = photoDtos => photoDtos.map(transformComplaintPhoto);
export const transformComplaintUser = user => ({
  id: user.id,
  login: user.login
});
export const transformComplaintResolution = resolution => ({
  action: resolution.action,
  isPrimary: resolution.is_primary,
  tip: resolution.tip,
  button: resolution.button,
  confirmTitle: resolution.confirm_title,
  confirmButton: resolution.confirm_button,
  confirmation: resolution.confirmation
});
export const transformComplaintEscalation = escalation => ({
  tip: escalation.tip,
  button: escalation.button,
  confirmTitle: escalation.confirm_title,
  confirmButton: escalation.confirm_button,
  confirmation: escalation.confirmation,
  englishAllowedVisible: escalation.english_allowed_visible,
  close: escalation.close
});
export const transformComplaint = complaint => ({
  buyerId: complaint.buyer_id,
  eligibleForReturnLabel: complaint.eligible_for_return_label,
  escalated: complaint.escalated,
  escalation: transformComplaintEscalation(complaint.escalation),
  id: complaint.id,
  message: complaint.message,
  transactionId: complaint.transaction_id,
  sellerId: complaint.seller_id,
  photos: transformComplaintPhotos(complaint.photos),
  resolutions: complaint.resolutions.map(transformComplaintResolution),
  faqEntry: transformFaqEntryDto(complaint.faq_entry),
  user: transformComplaintUser(complaint.user),
  returnable: complaint.returnable
});